import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Pressable, ScrollView, StyleSheet, Text } from "react-native";
import t from "@constants/localization";
import { scale } from "@utils/scale";
import color from "@constants/color";
import analytics from "@services/analytics";
import { actions } from "@reducers/shopPerformanceReducer";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import testIds from "@constants/testIds";
import SalesRow from "./SalesRow";

const PATH = "screens/ShopPerformance/Components/SalesModal/months";

const SalesModal = ({ visible, setVisible, month }) => {
  const { last8MonthsOverview, selectedMonth } = useSelector(
    ({ shopPerformance }) => shopPerformance,
  );
  const olderMonth = month;

  const dispatch = useDispatch();

  const months = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      presentationStyle="overFullScreen"
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={() => setVisible(false)}
    >
      <Pressable
        style={styles.container}
        onPress={() => {
          setVisible(false);
        }}
        testID={testIds.press_out_of_innerContainer}
      >
        <Pressable style={styles.innerContainer}>
          <Text style={styles.modalHeader}>{olderMonth}</Text>

          {last8MonthsOverview
            .slice(0)
            .reverse()
            .map((sale) => {
              return (
                <SalesRow
                  item={sale}
                  key={sale.month}
                  onPress={() => {
                    const newMonth = sale.month;

                    analytics.trackEvent(
                      SHOP_PERFORMANCE_EVENTS.MONTH_SELECTED,
                      {
                        Selected_Month: `${
                          months[parseInt(newMonth.substring(5, 7))]
                        }, ${newMonth.substring(0, 4)}`,
                      },
                    );
                    dispatch(
                      actions.updateSelectedMonth({
                        data: newMonth,
                      }),
                    );

                    setVisible(false);
                  }}
                  selectedSale={sale?.month === selectedMonth}
                />
              );
            })}
        </Pressable>
      </Pressable>
    </Modal>
  );
};

export default SalesModal;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.modalBackground,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 15,
  },
  innerContainer: {
    backgroundColor: color.white,
    borderRadius: 10,
    width: "90%",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingVertical: scale(20),
  },
  modalHeader: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: scale(32),
    lineHeight: scale(48),
    color: "#0000008f",
    marginBottom: scale(12),
    marginLeft: scale(24),
  },
});
